/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({"data":{"categories":{"cardinal":["few","many","one","other","two","zero"],"ordinal":["other"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const n = Math.abs(parseFloat(numStr));
    if (isOrdinal) {
    }
    else {
        if (((n % 100) >= 3 && (n % 100) <= 10))
            return "few";
        if (((n % 100) >= 11 && (n % 100) <= 99))
            return "many";
        if (n === 1)
            return "one";
        if (n === 2)
            return "two";
        if (n === 0)
            return "zero";
    }
    return "other";
}},"locale":"ars"})
} else {
  (globalThis.__FORMATJS_PLURALRULES_DATA__ = globalThis.__FORMATJS_PLURALRULES_DATA__ || []).push({"data":{"categories":{"cardinal":["few","many","one","other","two","zero"],"ordinal":["other"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const n = Math.abs(parseFloat(numStr));
    if (isOrdinal) {
    }
    else {
        if (((n % 100) >= 3 && (n % 100) <= 10))
            return "few";
        if (((n % 100) >= 11 && (n % 100) <= 99))
            return "many";
        if (n === 1)
            return "one";
        if (n === 2)
            return "two";
        if (n === 0)
            return "zero";
    }
    return "other";
}},"locale":"ars"})
}
